import { render, staticRenderFns } from "./QuizPagination.vue?vue&type=template&id=0eeb9f37&"
import script from "./QuizPagination.vue?vue&type=script&lang=js&"
export * from "./QuizPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports